
/* Page « Le smash burger » : la vidéo (lue seulement à l'écran), la frise qui avance,
   l'état des restaurants à l'heure de Paris (soirs de match à Lens compris), le burger de fin qui arrive du coin. */
(function(){
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var NB = String.fromCharCode(160);
  function q(s, r){ return (r || document).querySelector(s); }
  function qa(s, r){ return [].slice.call((r || document).querySelectorAll(s)); }

  /* ---- 2. La vidéo : lue seulement quand elle est à l'écran ---- */
  var vid = q('[data-geste]');
  if (vid){
    if (reduce){ vid.setAttribute('controls', ''); }
    else if ('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){
        if (e.isIntersecting){ var p = vid.play(); if (p && p.catch) p.catch(function(){ vid.setAttribute('controls', ''); }); }
        else vid.pause();
      }); }, {threshold: .35}).observe(vid);
    }
  }

  /* ---- 4. La frise avance au défilement ---- */
  var frise = q('[data-frise]');
  if (frise && !reduce){
    var ticking = false;
    var paintFrise = function(){
      ticking = false;
      var r = frise.getBoundingClientRect(), vh = window.innerHeight || 800;
      var p = Math.max(0, Math.min(1, (vh * .85 - r.top) / (r.height + vh * .35)));
      frise.style.setProperty('--p', p.toFixed(3));
    };
    frise.style.setProperty('--p', '0');
    window.addEventListener('scroll', function(){ if (!ticking){ ticking = true; requestAnimationFrame(paintFrise); } }, {passive: true});
    paintFrise();
  }

  /* ---- 6. L'état des restaurants, à l'heure de Paris ---- */
  var fmt = null;
  try { fmt = new Intl.DateTimeFormat('en-CA', {timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', hourCycle: 'h23'}); } catch(e){}
  function minutes(){
    var d = new Date();
    if (fmt){ var p = {}; fmt.formatToParts(d).forEach(function(x){ p[x.type] = x.value; }); return +p.hour * 60 + +p.minute; }
    return d.getHours() * 60 + d.getMinutes();
  }
  function label(c){ c = c % 1440; return c === 0 ? 'minuit' : Math.floor(c / 60) + 'h' + (c % 60 ? ('0' + c % 60).slice(-2) : ''); }
  function state(key){
    var t = minutes(), open = window.woodysOpen ? woodysOpen(key) : 690, close = 1380, late = (key === 'lens' && window.woodysLate) ? window.woodysLate() : null;
    if (late && late.yesterday && t < late.yesterday - 1440){ var e = late.yesterday - 1440; return {c: e - t <= 30 ? 'is-soon' : 'is-open', txt: (e - t <= 30 ? 'Ferme bientôt · ' : 'Ouvert · jusqu’à ') + label(late.yesterday)}; }
    if (late && late.today) close = late.today;
    if (t >= open && t < close) return {c: close - t <= 30 ? 'is-soon' : 'is-open', txt: (close - t <= 30 ? 'Ferme bientôt · ' : 'Ouvert · jusqu’à ') + label(close)};
    return {c: 'is-closed', txt: t < open ? 'Fermé · ouvre à ' + label(open) : 'Fermé · ouvre demain ' + label(window.woodysOpen ? woodysOpen(key, 1) : 690)};
  }
  var paintStates = function(){
    qa('[data-resto]').forEach(function(card){
      var s = state(card.getAttribute('data-resto')), el = q('[data-state]', card), tx = q('[data-state-t]', el);
      el.classList.remove('is-open', 'is-soon', 'is-closed'); el.classList.add(s.c);
      if (tx.textContent !== s.txt) tx.textContent = s.txt;
    });
  };
  paintStates(); setInterval(paintStates, 60000);

  /* ---- 8. Fin : le burger arrive du coin ---- */
  var end = q('[data-end]');
  if (end){
    end.classList.add('js');
    if ('IntersectionObserver' in window){ var io = new IntersectionObserver(function(es){ es.forEach(function(e){ if (e.isIntersecting){ end.classList.add('in'); io.disconnect(); } }); }, {threshold: .25}); io.observe(end); }
    else end.classList.add('in');
  }
})();

